import { Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import {
  CookbookSelectWrapper,
  DropdownOptionProps,
} from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { Meridian } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface MeridianSelectProps {
  name: string;
  id: string;
  disabled?: boolean;
  ariaLabel?: string;
}

export const meridianSelectOptions: DropdownOptionProps[] = [
  { text: 'AM', value: Meridian.AM },
  { text: 'PM', value: Meridian.PM },
];

export function MeridianSelect({
  name,
  id,
  disabled = false,
  ariaLabel = '',
}: MeridianSelectProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookSelectWrapper
      id={id}
      name={name}
      disabled={disabled}
      label={<Stack y="xxx-sm">&nbsp;</Stack>}
      ariaLabel={ariaLabel}
      error={errors[name]}
      control={control}
      options={meridianSelectOptions}
      blockWidth
    />
  );
}
